import React from "react";
import MasterForm from "./MasterForm";

function App() {
  return <MasterForm />;
}

export default App;
